"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import styles from './DateRangeInput.module.scss.mjs';
import * as Aria from 'react-aria-components';
import { Button } from '../../../Button/Button.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconDate } from '../../../Icon/components/icons/IconDate.mjs';

const DateRangeInput = (props) => {
  const { isDisabled } = props;
  return /* @__PURE__ */ jsxs(Aria.Group, { className: styles.dateRangeInput, children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Aria.DateInput, { slot: "start", children: (segment) => /* @__PURE__ */ jsx(Aria.DateSegment, { segment }) }),
      /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: "–" }),
      /* @__PURE__ */ jsx(Aria.DateInput, { slot: "end", children: (segment) => /* @__PURE__ */ jsx(Aria.DateSegment, { segment }) })
    ] }),
    /* @__PURE__ */ jsx(Button, { variant: "plain", color: "secondary", isDisabled, children: /* @__PURE__ */ jsx(IconDate, {}) })
  ] });
};

export { DateRangeInput, DateRangeInput as default };
//# sourceMappingURL=DateRangeInput.mjs.map
